(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["good-trail-fashion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trail-wardrobe')) {
  customElements.define('trail-wardrobe', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-filter]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-filter]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        this.querySelectorAll('[data-category]').forEach((card) => {
          card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
          if (!card.hidden) visible++;
        });
        this.querySelector('[data-results]').textContent = button.textContent.trim() + ': ' + visible;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["good-trail-fit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('trail-size-guide')){customElements.define('trail-size-guide',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-unit]');if(!button)return;this.querySelectorAll('[data-unit]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.querySelectorAll('[data-cm]').forEach(cell=>{cell.textContent=button.dataset.unit==='cm'?cell.dataset.cm+' '+this.dataset.cmLabel:(Number(cell.dataset.cm)/2.54).toFixed(2)+' '+this.dataset.inchLabel;});});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["good-trail-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('trail-gallery')){customElements.define('trail-gallery',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-trail-image]');if(!button)return;this.querySelectorAll('[data-trail-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.querySelectorAll('[data-trail-panel]').forEach(panel=>panel.hidden=panel.dataset.trailPanel!==button.dataset.trailImage);});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
